import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../CommonComponents/Modal';
import { Alert } from '../../../CommonComponents/Alert/Alert';
import { StyledButton as Button } from '../../../CommonComponents/Button';
import { StyledTitle, StyledErrorsWrapper, ActionsContainer } from './StyledComponents';

const DeleteModalView = ({
  clearErrors,
  clientId,
  closeModal,
  deleteTransaction,
  draftTransaction,
  errors,
  isOpen,
}) => (
  <Modal isOpen={isOpen} onRequestClose={closeModal}>
    {errors.length > 0 && (
      <StyledErrorsWrapper>
        <Alert appearance="info" message={errors} onRequestClose={clearErrors} />
      </StyledErrorsWrapper>
    )}
    <StyledTitle>
      {`Are you sure you want to delete the Transaction "${draftTransaction.description}"?`}
    </StyledTitle>
    <ActionsContainer>
      <Button onClick={closeModal}>Cancel</Button>
      <Button.Danger
        onClick={() => {
          deleteTransaction(clientId, draftTransaction.Id);
        }}
      >
        Confirm Delete
      </Button.Danger>
    </ActionsContainer>
  </Modal>
);

DeleteModalView.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  draftTransaction: PropTypes.shape({
    description: PropTypes.string,
    Id: PropTypes.string,
  }).isRequired,
  clientId: PropTypes.string.isRequired,
  deleteTransaction: PropTypes.func.isRequired,
};

export default DeleteModalView;
